export default "__VITE_ASSET__CYtIHzLL__"